// maplibre-gl 4 dropped the callback form of loadImage in favour of a promise
// that resolves to { data }. This wrapper keeps the rest of the app unaware.

export function addImage(map, id, url) {
  return map.loadImage(url).then(({ data }) => {
    // Layers re-add their icons whenever the style reloads; adding an id
    // that already exists throws.
    if(!map.hasImage(id)) {
      map.addImage(id, data);
    }
    return data;
  });
}

export function addImages(map, images) {
  const promises = images.map( imageData => addImage(map, imageData.id, imageData.url) );
  return Promise.all(promises);
}
